import { Controller } from '@hotwired/stimulus';

// The screen shell owns the metrics session. Only its placement class changes.
export default class extends Controller {
  static values = { placement: String };

  placementValueChanged() {
    const content = this.element.closest('.game-screen__frame')?.querySelector('#game_screen_container');
    if (!content) return;
    for (const position of ['top', 'right', 'bottom', 'left']) {
      content.classList.toggle(`game-screen__content--placement-${position}`, this.placementValue === position);
    }
  }
}
